/**
 * The four round-04 idea flags this lane renders (#73/#166, #137, #156, #76). L1 seeds them as
 * boolean `app_setting` rows — `flag.graph_view`, `flag.envelope_bars`, `flag.plan_versions`,
 * `flag.mentions` — OFF in code, ON in the demo layer; `/api/meta` mirrors every one as
 * `ideaFlags: { "flag.<name>": boolean }`. A flag meta does not name reads as OFF: a feature
 * the API does not report is not rendered (design.functional §5), and its routes answer 404.
 */
import { useMeta, type AppMeta } from '@/app/meta';

export type IdeaFlag = 'graphView' | 'envelopeBars' | 'planVersions' | 'mentions';

export const IDEA_FLAG_KEYS: Record<IdeaFlag, string> = {
  graphView: 'flag.graph_view',
  envelopeBars: 'flag.envelope_bars',
  planVersions: 'flag.plan_versions',
  mentions: 'flag.mentions',
};

/** Reads `ideaFlags` without depending on another lane's AppMeta type declaring it. */
export function ideaFlagOf(meta: AppMeta, flag: IdeaFlag): boolean {
  const flags = (meta as unknown as { ideaFlags?: Record<string, unknown> }).ideaFlags;
  return flags?.[IDEA_FLAG_KEYS[flag]] === true;
}

export function useIdeaFlag(flag: IdeaFlag): boolean {
  return ideaFlagOf(useMeta(), flag);
}
